import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Breadcrumbs from './Breadcrumbs';
import Container from './container';

export default function LayoutWithSidebar({
  header,
  sidebar,
  children,
  breadcrumbs,
  footer,
  className,
}) {
  return (
    <Container className={classnames(className)}>
      {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      {header && header()}
      {sidebar && (
        <div className="lg:grid lg:grid-cols-5 lg:gap-6">
          <div className="lg:col-span-1">{sidebar()}</div>
          <div className="lg:col-span-4">{children}</div>
        </div>
      )}
      {!sidebar && children}
      {footer && footer()}
    </Container>
  );
}

LayoutWithSidebar.propTypes = {
  children: PropTypes.node,
  sidebar: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
  ]),
  Breadcrumbs: PropTypes.shape({
    homeTitle: PropTypes.string,
    homeUrl: PropTypes.string,
    pages: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    ),
  }),
};
